import { AgentType } from '../models/enums/agent-type-enum';
import { WizardCompanyEnum } from '../models/enums/wizard-company.enum';

export const AgentRoutes = {
  [AgentType.Shareholder]: [
    WizardCompanyEnum.Data,
    WizardCompanyEnum.Partner,
    WizardCompanyEnum.Patrimonial,
    WizardCompanyEnum.Bank,
    WizardCompanyEnum.Representative,
    WizardCompanyEnum.Authorizations,
    WizardCompanyEnum.FiscalData,
    WizardCompanyEnum.Contract,
    WizardCompanyEnum.Beneficiaries,
    WizardCompanyEnum.PaymentAccountOpening,
    WizardCompanyEnum.Suitability,
    WizardCompanyEnum.AssetPortfolio,
    WizardCompanyEnum.FinancialInformation,
    WizardCompanyEnum.Confirmation
  ]
};
